<template>
    <div class="form-container" ref="fullscreen">
        <!-- Show "Enter Fullscreen" button if fullscreen is not active -->
        <div v-if="!isFullscreenActive" class="enter-fullscreen-box">
            <button class="btn btn-primary btn-lg" @click="showEnterPasswordModal = true">
                Enter Attendance Board
            </button>
        </div>

        <!-- Exit Fullscreen button -->
        <button class="exit-btn-top" v-if="isFullscreenActive" @click="attemptExitFullscreen">
            Exit Fullscreen
        </button>

        <img v-if="isFullscreenActive" :src="ptrImage" alt="PTR" class="ptr-image mb-3" />

        <!-- Attendance Form -->
        <!-- <h1 class="text-center" v-if="isFullscreenActive">Welcome <br /> to <br />Pathway to Recovery</h1>
        <hr />
        <br> -->
        <div v-if="isFullscreenActive" class="form-card">
            <h2>Attendance</h2>
            <hr />

            <Strong>Date : {{ $formatDate(currentDate) }}</Strong>
            <form @submit.prevent="handleSubmit">
                <p v-if="successMessage" class="text-success fw-bold">{{ successMessage }}</p>

                <!-- <div class="form-group">
                    <label for="pid">Enter PID</label>
                    <input type="text" id="pid" v-model="form.pid" class="form-control" required />
                </div> -->
                <div class="form-group">
                    <label for="pin">Please enter pin number for attendance</label>
                    <input type="password" id="pin" v-model="form.pin" class="form-control" required />
                    <p v-if="error" class="error-text">{{ error }}</p>
                </div>
                <div class="form-actions">
                    <button type="submit" class="btn btn-sm submit-btn" :disabled="loading">Mark Attendance</button>
                </div>

            </form>
        </div>

        <!-- Enter Fullscreen Password Modal -->
        <div class="modal-overlay" v-if="showEnterPasswordModal">
            <div class="modal">
                <h4>Enter password to enable fullscreen</h4>
                <input type="password" v-model="enterPassword" class="form-control" placeholder="Password" />
                <div class="modal-actions">
                    <button class="btn btn-sm submit-btn" @click="verifyAndEnterFullscreen">
                        Confirm
                    </button>
                    <button class="btn btn-danger btn-sm exit-btn ms-2" @click="showEnterPasswordModal = false">
                        Cancel
                    </button>
                </div>
                <p v-if="error" class="error-text">{{ error }}</p>
            </div>
        </div>

        <!-- Exit Fullscreen Password Modal -->
        <div class="modal-overlay" v-if="showPasswordModal">
            <div class="modal">
                <h4>Enter password to exit fullscreen</h4>
                <input type="password" v-model="exitPassword" class="form-control" placeholder="Password" />
                <div class="modal-actions">
                    <button class="btn btn-sm submit-btn" @click="verifyAndExit">
                        Confirm
                    </button>
                    <button class="btn btn-danger btn-sm exit-btn ms-2" @click="showPasswordModal = false">
                        Cancel
                    </button>
                </div>
                <p v-if="error" class="error-text">{{ error }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import emitter from '@/eventBus';
import ptrImage from '@/assets/ptr.jpeg';

export default {
    data() {
        return {
            form: {
                // pid: '',
                pin: ''
            },
            isFullscreenActive: false,
            showPasswordModal: false,
            showEnterPasswordModal: false,
            enterPassword: '',
            exitPassword: '',
            error: '',
            attendance: {},
            student: {},
            loading: false,
            successMessage: '',
            ptrImage,
            currentDate: new Date().toISOString().split("T")[0],
            currentTime: '',
            recordsCreated: 0,
        };
    },
    methods: {
        getLocalDate() {
            const now = new Date();
            const offsetMs = now.getTimezoneOffset() * 60 * 1000;
            const localISOTime = new Date(now.getTime() - offsetMs).toISOString().split('T')[0];
            return localISOTime;
        },
        updateCurrentTime() {
            const now = new Date();
            this.currentTime = now.toLocaleTimeString(); // e.g., 12:34:56 PM
        },
        enterFullScreenEvent() {
            emitter.emit('toggle-fullscreen', true);
        },
        exitFullScreenEvent() {
            emitter.emit('toggle-fullscreen', false);
        },
        // handleSubmit() {
        //     console.log('Submitted:', this.form);
        //     // Add your submission logic here
        // },
        attemptExitFullscreen() {
            this.showPasswordModal = true;
            this.exitPassword = '';
            this.error = '';
        },
        async verifyAndExit() {
            try {
                const res = await this.$api.post('/verify-password', {
                    password: this.exitPassword
                });
                if (res.status === 200) {
                    this.exitFullscreen();
                }
            } catch (err) {
                this.error = 'Invalid password. Try again.';
            }
        },

        async verifyAndEnterFullscreen() {
            try {
                const res = await this.$api.post('/verify-password', {
                    password: this.enterPassword
                });
                if (res.status === 200) {
                    this.enterFullscreen();
                }
            } catch (err) {
                this.error = 'Invalid password. Try again.';
            }
        },

        getCurrentTime24() {
            const date = new Date();
            return date.toTimeString().split(" ")[0];
        },
        async markAttendance() {
            // const attendanceData = {
            //     student_id: this.selectedStudent.id,
            //     day_name: this.selectedDay,
            //     attendance_date: this.selectedDate,
            //     counselor_id: this.selectedCounselor,
            //     time_slot_id: this.selectedTimeSlot,
            //     group_id: this.selectedGroup,

            //     time: this.currentTime,
            //     status: "present",
            //     notes: "Auto-marked"
            // };

            this.recordsCreated = 0;
            this.attendance.counselor_id = 0;
            this.attendance.status = 'present';
            this.attendance.notes = "by Student";
            this.attendance.time = this.getCurrentTime24();
            this.attendance.date = this.currentDate;

            try {
                const response = await this.$api.post("/attendance", this.attendance);
                const res = response.data;

                if (res.request_status === false) {
                    this.error = res.message || 'Could not mark attendance.';
                    this.recordsCreated = 0;
                    return { success: false, message: this.error, recordsCreated: 0 };
                }

                this.recordsCreated = res.recordsCreated || 0;
                return { success: true, message: res.message, recordsCreated: this.recordsCreated };

            } catch (error) {
                this.recordsCreated = 0;
                if (error.response?.status === 422) {
                    this.error = error.response.data.message || 'Validation failed.';
                } else {
                    console.error("Error saving attendance", error);
                    this.error = "An error occurred while saving attendance.";
                }
                return { success: false, message: this.error, recordsCreated: 0 };
            }
        },

        async handleSubmit() {
            try {
                this.error = '';
                this.loading = true;
                const res = await this.$api.post('/student_by_pin', {
                    pin: this.form.pin
                });

                const data = res.data;

                if (data.valid === 'false' || data.valid === false) {
                    this.error = data.message || 'Invalid PIN.';
                    return;
                }

                // Success
                let student = data.message;

                this.attendance.student_id = student.id // Store student object
                this.attendance.group_id = student.group_id;
                // currentDate: new Date().toISOString().split("T")[0],
                // this.form.pin = ''; // Clear the pin field
                // this.error = '';
                const attendanceResult = await this.markAttendance();

                if (!attendanceResult.success) {
                    this.error = attendanceResult.message;
                    return;
                }

                // ✅ Show success message based on attendance result
                if (attendanceResult.recordsCreated === 0) {
                    this.successMessage = "Welcome, " + (student.user.name || 'Student') + "! Your attendance is already marked for today.";
                } else {
                    this.successMessage = "Welcome, " + (student.user.name || 'Student') + "! Your attendance has been marked successfully.";
                }
                // this.successMessage = "Welcome, " + (student.user.name || 'Student') + "! your attendance is marked successfully.";
                setTimeout(() => {
                    this.successMessage = "";
                }, 4000);

                // console.log(successMessage);
                // Optionally, send another API call to mark attendance

            } catch (error) {
                this.error = 'Something went wrong. Please try again.';
            } finally {
                this.loading = false;
                // this.error = "";
            }
        },

        enterFullscreen() {
            // const el = this.$refs.fullscreen;
            this.error = '';
            this.enterPassword = '';
            this.showEnterPasswordModal = false;
            // this.$store.dispatch('setFullScreen', true);
            this.enterFullScreenEvent();
            // if (el.requestFullscreen) el.requestFullscreen();
            // else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
            // else if (el.msRequestFullscreen) el.msRequestFullscreen();
            this.isFullscreenActive = true;
        },
        exitFullscreen() {
            this.showPasswordModal = false;
            this.exitPassword = '';
            this.error = '';
            // if (document.fullscreenElement) {
            //     document.exitFullscreen();
            // }
            this.$store.dispatch('setFullScreen', false);
            this.isFullscreenActive = false;
            this.exitFullScreenEvent();
        },
        handleKeyDown(e) {
            // Prevent ESC from exiting fullscreen
            if (e.key === 'Escape') {
                e.preventDefault();
            }

            // Prevent refresh
            if (
                e.key === 'F5' ||
                (e.ctrlKey && e.key === 'r') || // Ctrl+R
                (e.metaKey && e.key === 'r')    // Cmd+R for Mac
            ) {
                e.preventDefault();
            }
        }

    }
    , mounted() {
        // document.addEventListener('keydown', this.handleKeyDown);
        // document.addEventListener('contextmenu', (e) => e.preventDefault());
        this.updateCurrentTime();
        this.isFullscreenActive = this.$store.getters.isFullScreen;
        this.timeInterval = setInterval(this.updateCurrentTime, 1000);

        this.enterFullscreen();
        this.currentDate = this.getLocalDate();

    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
        clearInterval(this.timeInterval);
        this.$store.dispatch('setFullScreen', false);
        this.exitFullScreenEvent();


    }
};
</script>

<style scoped>
.ptr-image {
    max-width: 300px;
    margin-bottom: 20px;
    border-radius: 10px;
}

.form-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    min-width: 100%;
    background: #f8f9fa;
    padding: 20px;
    flex-direction: column;
}

.enter-fullscreen-box {
    text-align: center;
}

.exit-btn {
    background-color: #dc3545;
}

.exit-btn-top {
    position: absolute;
    top: 20px;
    right: 20px;
    min-width: 150px;
    padding: 8px 12px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
}

.form-card {
    background: white;
    padding: 30px;
    border-radius: 10px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2 {
    margin-bottom: 10px;
}

.form-group {
    margin-bottom: 15px;
}

.form-control {
    width: 100%;
    padding: 8px 12px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.submit-btn {
    min-width: 150px;
    font-weight: bold;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: white;
    padding: 20px 30px;
    border-radius: 10px;
    width: 90%;
    max-width: 400px;
    text-align: center;
}

.modal-actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}

.error-text {
    color: red;
    margin-top: 10px;
}
</style>